module.exports = function(fetcher, urlFormatter) {
    const module = {};

    module.getRedemptionConditions = function({bookingId, bookingItemId}) {
        return fetcher.get(urlFormatter(`checkOpenTicketConditions/${bookingId}/${bookingItemId}`)).json()
            .catch(() => {
                return {inScope: false};
            });
    };

    module.getOpenTicketStatus = function({bookingId, bookingItemId}) {
        return fetcher.get(urlFormatter(`getOpenTicketStatus/${bookingId}/providerBookingItemId/${bookingItemId}`)).json();
    };

    return module;
};
